import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
const Container = styled.div.withConfig({
  componentId: "sc-1opyqtz-0"
})(["position:relative;width:100%;flex:1 0 auto;z-index:1;"]);

const PanelMain = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, props, children);
};

PanelMain.propTypes = {
  /** Main content for panel */
  children: PropTypes.node.isRequired
};
export default PanelMain;